// extracted by mini-css-extract-plugin
export default {"container":"Ko-z","ratingLayout":"Lo-z","ratingLabel":"Mo-z","nonInteractiveRatingLabel":"No-z"};